module.exports = __webpack_public_path__ + "img/1723086410433-donat aulia.jpg.1838e9d3.webp";